


















import { Component, Prop, Vue } from "vue-property-decorator";

import { DebugHelper } from "@/helper/debugHelper";
import { UuidHelper } from '@/helper/uuidHelper';
import { RequestHelper } from "@/helper/requestHelper";
import { CookieHelper } from "@/helper/cookieHelper";

@Component({
  components: {
  }
})

export default class DeleteAccountDoneModal extends Vue {
    @Prop() private onetimePass! : string;

    title = "ユーザー登録削除";

    private get message(){
        return "ユーザー登録削除を実行します。";
    }

    private onOk(){
        // コード送信処理
        var param = {
            uuid : CookieHelper.hasItem("authorizationToken") ? CookieHelper.getItem("authorizationToken") : "",
            onetimePass : this.onetimePass
        };

        RequestHelper.post("delete_user", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace(res);
            if(res.message.length > 0){
                DebugHelper.trace(res.message);
                var messageList = res.message;
                this.$emit("error", messageList);
                this.$emit("close");
            }
            else{
                this.$emit("deleteDone");
                this.$emit("close");
            }
        }, () => {
            DebugHelper.trace("エラー");
        });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
}
